import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import useNavigation from "../../Utility/hooks/useNavigation";
import './widgets.css'

export const OpenInNewButton = ({ href, tooltip }) => {
    const { openInNewTab } = useNavigation();

    if (!href) return null;

    return (
        <Tooltip title={tooltip}>
            <IconButton
                className = "open-in-new-button"
                size="small"
                onClick={() => openInNewTab(href)}
                sx={{ mb: "4px" }}
            >
                <OpenInNewIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};